import { ReactNode } from 'react';

import ExpandMore from '@mui/icons-material/ExpandMore';
import { AccordionSummary, AccordionSummaryProps, alpha, Typography } from '@mui/material';

import styled from 'styled-components';

import { ThemeFunction } from '../../../utils';

const StyledPortfolioAccordionSummary = styled(
  (props: Omit<AccordionSummaryProps, 'expandIcon'> & { $colorFn: ThemeFunction<string> }) => (
    <AccordionSummary {...props} expandIcon={<ExpandMore className="expand-more" />} />
  )
)`
  &.MuiAccordionSummary-root {
    background-color: ${({ theme, $colorFn }) => alpha($colorFn(theme), 0.05)};
    border-radius: ${({ theme }) => theme.spacing(1, 1, 0, 0)};
    flex-direction: row-reverse;
    gap: ${({ theme }) => theme.spacing(2)};
    padding: ${({ theme }) => theme.spacing(0, 2)};
    height: 80px;
  }

  & .MuiAccordionSummary-content {
    align-items: center;

    *:last-child {
      margin-left: auto;
    }
  }

  .expand-more {
    background-color: ${({ theme, $colorFn }) => $colorFn(theme)};
    border-radius: 50%;
    color: ${({ theme }) => theme.palette.neutrals.white};
  }
`;

export interface PortfolioAccordionSummaryProps {
  className?: string;
  color: ThemeFunction<string>;
  title: ReactNode;
  children?: ReactNode;
}

export const PortfolioAccordionSummary = ({ children, className, color, title }: PortfolioAccordionSummaryProps) => {
  return (
    <StyledPortfolioAccordionSummary className={className} $colorFn={color}>
      <Typography variant="body1.semibold">{title}</Typography>
      {children}
    </StyledPortfolioAccordionSummary>
  );
};
